module.exports = __webpack_public_path__ + "./docs/img/icon-function.1b66cf98481d920333836a6df2ad4b1c.svg";